/* 
Menu Types:
"menu-default", "menu-sub-hidden", "menu-hidden"
*/
export const defaultMenuType = "menu-default";

export const subHiddenBreakpoint = 1440;
export const menuHiddenBreakpoint = 768;
export const defaultLocale = "en";
export const localeOptions = [
  { id: "en", name: "English - LTR", direction: "ltr" },
  { id: "es", name: "Español", direction: "ltr" },
  { id: "enrtl", name: "English - RTL", direction: "rtl" },
];

export const firebaseConfig = {
  apiKey: "AIzaSyBBksq-Asxq2M4Ot-75X19IyrEYJqNBPcg",
  authDomain: "gogo-react-login.firebaseapp.com",
  databaseURL: "https://gogo-react-login.firebaseio.com",
  projectId: "gogo-react-login",
  storageBucket: "gogo-react-login.appspot.com",
  messagingSenderId: "216495999563",
};

export const smartsightAPI = "https://demo.darsa.ai";
// export const smartsightAPI = "http://192.168.5.106:8000";
// export const smartsightAPI = "http://192.168.1.109";
export const searchPath = "/app/pages/search";
export const servicePath = "https://api.coloredstrategies.com";

export const peopleLogDay = "/api/log/people_count/";
export const salesTransactionLogDay = "/api/log/sales_transaction/";

export const peopleCountSummaryDay = "/api/summary/day/people_count/";
export const salesTransactionSummaryDay = "/api/summary/day/sales_transaction/";

export const peopleCountSummaryMonth = "/api/summary/month/people_count/";
export const salesTransactionSummaryMonth =
  "/api/summary/month/sales_transaction/";

export const peoplecsm = "/api/summary/month/people_count/";
export const salestsm = "/api/summary/month/sales_transaction/";

export const facilityAll = "/api/facility_all/";
export const roster = "/api/roaster/fac_emp_count/";

/* 
Color Options:
"light.purple", "light.blue", "light.green", "light.orange", "light.red", "dark.purple", "dark.blue", "dark.green", "dark.orange", "dark.red"
*/
export const isMultiColorActive = false;
export const defaultColor = "light.orange";
export const defaultDirection = "ltr";
export const isDarkSwitchActive = true;
export const themeColorStorageKey = "__theme_color";
export const themeRadiusStorageKey = "__theme_radius";
export const isDemo = false;

export const darsaURL = "sfx.darsa.ai";
// export const darsaURL = "192.168.5.106:8000";
// export const darsaURL = "192.168.1.109";
